<template>
  <header id="bjzc-header">
    <div class="bjzc-top">
      <div class="primary-bar"></div>
      <div class="uk-flex uk-flex-middle uk-container uk-position-cover">
        <span class="uk-visible@m">{{ $t('messages.hello') }}</span>
        <div id="lang-toggle" class="uk-visible@m">
          <a href="javascript:;" :class="{ 'is-current': currentLang === 'zh' }" @click="changeLanguage('zh')"
            >简体中文</a
          >
          <span> / </span>
          <a href="javascript:;" :class="{ 'is-current': currentLang === 'en' }" @click="changeLanguage('en')"
            >English</a
          >
        </div>
      </div>
      <div class="bjzc-contact-info">
        <span class="uk-flex uk-flex-middle uk-margin-right">
          <span uk-icon="icon: receiver;ratio: 0.8"></span>
          <span>&nbsp;010-67665196</span>
        </span>
        <span class="uk-flex uk-flex-middle">
          <span uk-icon="icon: phone;ratio: 0.8"></span>
          <span>&nbsp;13910962198</span>
        </span>
      </div>
    </div>
    <div class="bjzc-navbar" uk-sticky="">
      <!-- <div class="bjzc-navbar"> -->
      <nav class="uk-container" uk-navbar="">
        <div class="uk-navbar-left">
          <router-link class="uk-logo" to="/">
            <img src="~@/assets/images/logo-header.png" alt="" />
          </router-link>
        </div>
        <div class="uk-navbar-right">
          <ul id="normal-navbar" class="uk-navbar-nav uk-visible@m">
            <li v-for="nav in navbarList" :key="nav.value">
              <router-link :to="nav.path">
                <div class="uk-text-center">
                  <div>
                    <span>{{ $t(`nav.${nav.value}`) }}</span>
                    <span v-if="nav.children && nav.children.length" uk-icon="icon: triangle-down;ratio: 0.8;"></span>
                  </div>
                  <div>{{ $t(`nav.${nav.value}_en`) }}</div>
                </div>
              </router-link>
              <div v-if="nav.children && nav.children.length" class="uk-navbar-dropdown">
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li v-for="subnav in nav.children" :key="subnav.value">
                    <router-link :to="subnav.path">{{ $t(subnav.value) }}</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <!-- 抽屉侧边栏触发按钮 -->
          <a
            id="offcanvas-navbar-toggle"
            class="uk-navbar-toggle uk-hidden@m"
            uk-navbar-toggle-icon
            uk-toggle="target: #offcanvas-navbar"
          ></a>
        </div>
      </nav>

      <!-- 抽屉侧边栏 -->
      <div id="offcanvas-navbar" uk-offcanvas="flip: true;overlay: true">
        <div class="uk-offcanvas-bar">
          <ul class="uk-nav uk-nav-center uk-nav-parent-icon" uk-nav>
            <li v-for="nav in navbarList" :key="nav.value" :class="{ 'uk-parent': nav.children }">
              <router-link :to="nav.path">
                <div class="uk-text-center">
                  <div>
                    <span>{{ $t(`nav.${nav.value}`) }}</span>
                    <span v-if="nav.children && nav.children.length" uk-icon="icon: triangle-down;ratio: 0.8;"></span>
                  </div>
                  <div>{{ $t(`nav.${nav.value}_en`) }}</div>
                </div>
              </router-link>
              <ul v-if="nav.children && nav.children.length" class="uk-nav-sub">
                <li v-for="subnav in nav.children" :key="subnav.value">
                  <router-link :to="subnav.path">{{ $t(subnav.value) }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
          <div class="uk-text-center uk-padding">
            <div id="lang-toggle" class="uk-margin-remove">
              <a href="javascript:;" :class="{ 'is-current': currentLang === 'zh' }" @click="changeLanguage('zh')"
                >简体中文</a
              >
              <span> / </span>
              <a href="javascript:;" :class="{ 'is-current': currentLang === 'en' }" @click="changeLanguage('en')"
                >English</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { services } from '../lib/options'
export default {
  name: '',
  components: {},
  data() {
    return {
      navbarList: [
        {
          path: '/',
          value: 'home',
          children: null
        },
        {
          path: '/about',
          value: 'about',
          children: null
        },
        {
          path: '',
          value: 'service',
          children: services.map(s => ({
            path: '/service/' + s,
            value: 'service.' + s
          }))
        },
        {
          path: '/team',
          value: 'team',
          children: null
        },
        {
          path: '/activity',
          value: 'activity',
          children: null
        },
        {
          path: '/invite',
          value: 'invite',
          children: null
        },
        {
          path: '/contact',
          value: 'contact',
          children: null
        }
      ]
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale
    }
  },
  created() {
    this.getServices()
  },
  methods: {
    changeLanguage(lang) {
      this.$root.$i18n.locale = lang

      localStorage.setItem('lang', lang)
      window.document.title = this.$t('app.title')
    },
    hideOffcanvas() {
      window.UIkit.offcanvas('#offcanvas-navbar').hide()
    },
    getServices() {
      this.$axios.get('single_pages', { params: { type: 'PageClan::ServicePage' } }).then(res => {
        this.navbarList[2].children = res.data.map(s => ({
          path: '/service/' + s.code,
          value: 'service.' + s.code
        }))
      })
    }
  },
  watch: {
    $route: 'hideOffcanvas'
  }
}
</script>

<style lang="scss">
#bjzc-header {
  .bjzc-top {
    height: 2rem;
    position: relative;
  }
  .primary-bar {
    position: absolute;
    top: 0;
    width: 100%;
    height: 3px;
    background-color: $color-primary;
    z-index: 2;
  }
  .bjzc-contact-info {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    color: #fff;
    background-color: $color-primary;
    display: flex;
    align-items: center;
    padding: 0 3rem;
  }
  .bjzc-contact-info::after {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 0;
    border-bottom: 2rem solid #f0f0f0;
    border-right: 1.2rem solid transparent;
  }

  /* 语言切换 */
  #lang-toggle {
    margin: 0 auto 0 1.88rem;
    & > * {
      color: #97999f;
    }
    a.is-current {
      color: $color-primary;
      cursor: default;
      pointer-events: none;
    }
  }

  /* navbar */
  .bjzc-navbar {
    background-color: #fff;
    /* padding: 0 7.5rem; */
  }
  .bjzc-navbar.uk-sticky-fixed {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  }
  .bjzc-navbar .uk-logo {
    height: 2.63rem;
    img {
      height: 100%;
    }
  }
  .bjzc-navbar .uk-navbar-nav > li > a {
    height: 4.38rem;
    min-height: 4.38rem;
  }
  .bjzc-navbar .uk-navbar-nav > li > a > div > :nth-child(1) {
    color: #494d54;
  }
  .bjzc-navbar .uk-navbar-nav > li > a > div > :nth-child(2) {
    color: #cccccc;
    font-size: 0.75rem;
    font-weight: 600;
  }
  .bjzc-navbar .uk-navbar-nav > li.uk-active > a > div > :nth-child(1),
  .bjzc-navbar .uk-navbar-nav > li:hover > a > div > :nth-child(1) {
    color: $color-primary;
  }
  .bjzc-navbar .uk-navbar-dropdown {
    margin-top: 0;
    padding: 0;
  }
  .bjzc-navbar .uk-navbar-dropdown li > a {
    color: #494d54;
    padding: 1rem;
  }
  .bjzc-navbar .uk-navbar-dropdown li:hover > a,
  .bjzc-navbar .uk-navbar-dropdown li.uk-active > a {
    color: $color-primary;
  }

  #offcanvas-navbar-toggle {
    min-height: 3.15rem;
    position: relative;
    z-index: 1001;
  }
  #offcanvas-navbar {
    top: 2rem;
  }
  .bjzc-navbar.uk-sticky-fixed #offcanvas-navbar {
    top: 0;
  }
  #offcanvas-navbar .uk-offcanvas-bar {
    background-color: #fff;
    padding: 0;
    padding-top: 3.15rem;
    width: 20rem;
  }
  #offcanvas-navbar .uk-offcanvas-bar .uk-nav-parent-icon > .uk-parent > a::after {
    display: none;
  }
  #offcanvas-navbar .uk-nav a {
    color: #494d54;
    border-bottom: 1px solid #f0f0f0;

    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #offcanvas-navbar .uk-nav > li > a > div > :nth-child(2) {
    color: #cccccc;
    font-size: 0.75rem;
    font-weight: 600;
  }
  #offcanvas-navbar .uk-nav li.uk-active > a > div > :nth-child(1),
  #offcanvas-navbar .uk-nav li > a:hover > div > :nth-child(1),
  #offcanvas-navbar .uk-nav .uk-nav-sub li > a:hover {
    color: $color-primary;
  }
}
@media (max-width: ($screen-width-m - 1)) {
  #bjzc-header .primary-bar {
    height: 2px;
  }
  #bjzc-header .bjzc-contact-info {
    padding: 0 0.65rem 0 2.15rem;
  }
}
</style>
